export const EMAILS = {
  SUPPORT_EMAIL: 'support@businesskitz.com.au',
  SALES_EMAIL: 'sales@businesskitz.com.au',
};
